export const buttonMargin = 8;
export const baseWABButtonSharedStyle = {
    marginBottom: buttonMargin,
};
export const baseWABButtonMarginRightStyle = {
    marginRight: buttonMargin / 2,
};
export const baseWABButtonMarginLeftStyle = {
    marginLeft: buttonMargin / 2,
};
export const getWizardActionBarStyles = (props) => {
    return {
        subComponentStyles: {
            back: (() => {
                return {
                    root: [
                        baseWABButtonSharedStyle,
                        baseWABButtonMarginRightStyle,
                        baseWABButtonMarginLeftStyle,
                    ],
                };
            })(),
            main: (() => {
                return {
                    root: [
                        baseWABButtonSharedStyle,
                        baseWABButtonMarginRightStyle,
                        baseWABButtonMarginLeftStyle,
                    ],
                };
            })(),
            saveclose: (() => {
                return { root: [baseWABButtonSharedStyle, baseWABButtonMarginRightStyle] }; // accounts for hover backplate
            })(),
            cancel: (() => {
                return { root: [baseWABButtonSharedStyle] }; // accounts for hover backplate
            })(),
        },
    };
};
//# sourceMappingURL=WizardActionBar.styles.js.map